export default function headerSticky(element, data) {
    const stickyEl = document.querySelector('.page-header');
    let stickyElHeight = stickyEl.offsetHeight;
    let lastScrollTop = 0;

    window.addEventListener('scroll', () => {       
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        let top = stickyEl.offsetHeight * (-1) + "px";

        if (scrollTop > lastScrollTop) {
            stickyEl.style.top = top;
        } else {
            stickyEl.style.top = "0";
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
};